export const setStorage = (value, key) => {
  if (!value) return;

  localStorage.setItem(key, value.toString());
  sessionStorage.setItem(key, value.toString());
  window.windowUid = value.toString();
  window.browserInfo = value.toString();
};
